"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.history = exports.persistor = exports.store = exports.getSelectedCompanyId = exports.getToken = void 0;
var redux_1 = require("redux");
var react_router_redux_1 = require("react-router-redux");
var redux_thunk_1 = require("redux-thunk");
var redux_logger_1 = require("redux-logger");
var history_1 = require("history");
var redux_persist_1 = require("redux-persist");
var storage_1 = require("redux-persist/lib/storage"); // defaults to localStorage for web
var redux_devtools_extension_1 = require("redux-devtools-extension");
var server_1 = require("./helpers/server");
var UserActions_1 = require("./pages/userManagement/UserActions");
var reducers_1 = require("./pages/_shared/reducers/");
var MapActions_1 = require("./pages/livemap/MapActions");
var HourControlReducer_1 = require("./pages/_shared/reducers/hourControlState/HourControlReducer");
var UserManagementReducer_1 = require("./pages/userManagement/UserManagementReducer");
var MapReducer_1 = require("./pages/livemap/MapReducer");
var LoginReducer_1 = require("./pages/_shared/reducers/loginState/LoginReducer");
var ProjectReducer_1 = require("./pages/searchProject/ProjectReducer");
var ProjectActions_1 = require("./pages/searchProject/ProjectActions");
var reducers_2 = require("./pages/settings/reducers");
var reducer_1 = require("./pages/report/reducer");
var reducer_2 = require("./pages/_shared/weekDays/reducer");
var SideMenuReducer_1 = require("./pages/sideMenu/SideMenuReducer");
var history = (0, history_1.createBrowserHistory)();
exports.history = history;
var middleware = (0, react_router_redux_1.routerMiddleware)(history);
var loggerMiddleware = (0, redux_logger_1.createLogger)();
// Only need to add the APIs which you want actually to control the state
var api = (0, redux_1.combineReducers)({
    weekOverview: (0, server_1.createApiReducer)(reducers_1.HourControlActions.WEEK_HOURS),
    searchUsers: (0, server_1.createApiReducer)(UserActions_1.UserActions.GET_USERS),
    lastLocation: (0, server_1.createApiReducer)(MapActions_1.MapActions.USERS),
    login: (0, server_1.createApiReducer)(reducers_1.LoginActions.LOGIN),
    userWorkLogList: (0, server_1.createApiReducer)(reducers_1.HourControlActions.WORKLIG_LIST),
    addWorkLog: (0, server_1.createApiReducer)(reducers_1.HourControlActions.ADD_WORKLOG),
    updateUser: (0, server_1.createApiReducer)(UserActions_1.UserActions.UPDATE_API),
    userDayWorkLogs: (0, server_1.createApiReducer)(reducers_1.HourControlActions.GET_USER_LOG),
    userGpsNodes: (0, server_1.createApiReducer)(reducers_1.HourControlActions.GET_USER_GPS_NODES),
    userSteps: (0, server_1.createApiReducer)(reducers_1.HourControlActions.GET_USER_STEPS),
    searchProjects: (0, server_1.createApiReducer)(ProjectActions_1.ProjectActions.SEARCH),
    saveWorkLogs: (0, server_1.createApiReducer)(reducers_1.HourControlActions.SAVE_LOG_IN_SERVER),
});
var persistConfig = {
    key: 'MSQ_HOURS_PORTAL',
    storage: storage_1.default,
};
var reducer = (0, redux_1.combineReducers)({
    authentication: LoginReducer_1.default,
    locationsState: MapReducer_1.default,
    manageUsersState: UserManagementReducer_1.default,
    hourReducer: HourControlReducer_1.default,
    projectsReducer: ProjectReducer_1.default,
    SettingsReducer: reducers_2.default,
    WeekDaysReducer: reducer_2.default,
    reportReducer: reducer_1.default,
    sideMenuReducer: SideMenuReducer_1.default,
    api: api,
});
var persistedReducer = (0, redux_persist_1.persistReducer)(persistConfig, (0, redux_1.combineReducers)({
    reducer: reducer,
    router: react_router_redux_1.routerReducer,
}));
var store = (0, redux_1.createStore)(persistedReducer, (0, redux_devtools_extension_1.composeWithDevTools)((0, redux_1.applyMiddleware)(
// loggerMiddleware,
redux_thunk_1.default.withExtraArgument(middleware))));
exports.store = store;
var persistor = (0, redux_persist_1.persistStore)(store);
exports.persistor = persistor;
/**
 *  Getting the state directly from the store is not a good pattern and
 *  disallowed in most cases EXCEPT authentication and token cases.
 */
var getToken = function () {
    return store.getState().reducer.authentication.token;
};
exports.getToken = getToken;
/**
 *  Get selected company ID for admin users.
 *  Used by server.ts to add X-Company-Id header to API requests.
 */
var getSelectedCompanyId = function () {
    return store.getState().reducer.sideMenuReducer.selectedCompanyId;
};
exports.getSelectedCompanyId = getSelectedCompanyId;
